module.exports = __webpack_public_path__ + "static/img/kefu.1600037.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kefu.jpg
// module id = s62t
// module chunks = 9